import React from 'react';

const VMK_TEAL = '#179f9f';

const iconProps = {
  className: 'vmk-investment-included-icon',
  width: 40,
  height: 40,
  viewBox: '0 0 48 48',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const s = {
  stroke: VMK_TEAL,
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const VmkIncludedSurveyIcon = () => (
  <svg {...iconProps}>
    <rect x="12" y="8" width="24" height="32" rx="2" {...s} />
    <path d="M18 16h12M18 22h12M18 28h8" {...s} />
    <path d="M30 34l6 6" {...s} />
    <circle cx="33" cy="37" r="3.5" {...s} />
  </svg>
);

export const VmkIncludedProductionIcon = () => (
  <svg {...iconProps}>
    <path d="M10 38V18l8-6 8 6v20" {...s} />
    <path d="M26 38V22l8-6 4 3v19" {...s} />
    <path d="M16 38V28h6v10" {...s} />
    <path d="M8 20l6-4M40 20l-6-4" {...s} />
  </svg>
);

export const VmkIncludedDeliveryIcon = () => (
  <svg {...iconProps}>
    <path d="M8 30h26l4-8V14H8v16z" {...s} />
    <circle cx="16" cy="34" r="3" {...s} />
    <circle cx="32" cy="34" r="3" {...s} />
    <path d="M34 22h6l3 6v2h-9" {...s} />
  </svg>
);

export const VmkIncludedInstallIcon = () => (
  <svg {...iconProps}>
    <path d="M14 34l10-18 10 18" {...s} />
    <path d="M18 28h12" {...s} />
    <path d="M24 10v6" {...s} />
    <path d="M20 14h8" {...s} />
  </svg>
);

export const VmkIncludedRemovalIcon = () => (
  <svg {...iconProps}>
    <path d="M14 14h20l-2 24H16L14 14z" {...s} />
    <path d="M10 14h28" {...s} />
    <path d="M20 14V10h8v4" {...s} />
    <path d="M22 20v12M26 20v12" {...s} />
  </svg>
);

export const VmkIncludedAdjustIcon = () => (
  <svg {...iconProps}>
    <rect x="10" y="12" width="28" height="24" rx="2" {...s} />
    <path d="M10 24h28" {...s} />
    <path d="M24 12v24" {...s} />
    <path d="M30 18h6M30 30h6" {...s} />
  </svg>
);

export const VmkIncludedAftercareIcon = () => (
  <svg {...iconProps}>
    <path d="M24 8l14 6v10c0 10-6 16-14 18-8-2-14-8-14-18V14l14-6z" {...s} />
    <path d="M18 24l4 4 8-8" {...s} />
  </svg>
);

export const VMK_INVESTMENT_INCLUDED_ICONS = [
  VmkIncludedSurveyIcon,
  VmkIncludedProductionIcon,
  VmkIncludedDeliveryIcon,
  VmkIncludedInstallIcon,
  VmkIncludedRemovalIcon,
  VmkIncludedAdjustIcon,
  VmkIncludedAftercareIcon,
];
